<template>
  <div>
    <el-submenu :index="subMenu.path" :key="subMenu.path" v-if="subMenu.children && subMenu.meta.menuShow">
      <template slot="title">
        <svg-icon :icon-class="subMenu.meta.icon" />
        <span>{{ subMenu.meta.title }}</span>
      </template>
      <MenuList v-for="item in subMenu.children" :key="item.path" :subMenu="item" />
    </el-submenu>
    <el-menu-item :index="subMenu.path" :key="subMenu.path" v-if="!subMenu.children && subMenu.meta.menuShow" @click="openLabel(subMenu)">
      <svg-icon :icon-class="subMenu.meta.icon" />
      <span slot="title">{{ subMenu.meta.title }}</span>
      <span v-if="subMenu.meta.title=='新的订单'" style="color:red;float:right;paddingRight:65px;fontWeight:800">({{NUM}})</span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: ["subMenu"],
  name: "MenuList",
  created() {},
  computed:{
    NUM() {
      return this.$store.getters.NUM
    }
  },
  methods: {
    ...mapMutations(["addTagList"]),
    // 打开一个新标签
    openLabel(obj) {
      let data = {
        name: obj.name,
        path: obj.path,
        title: obj.meta.title,
      };
      this.$store.commit('DEL_KEEP_ALIVE',obj.name)
      this.$store.commit('SET_PAGETITLE',obj.meta.title)
      this.addTagList(data);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-submenu__title {
  height: 56px;
  line-height: 56px;
  padding: 0 10px !important;
}
/deep/.el-submenu .el-menu-item {
  padding: 0 20px !important;
}
/deep/.el-submenu .el-submenu .el-submenu__title {
  padding: 0 20px !important;
}
/deep/.el-submenu .el-submenu .el-menu-item {
  padding: 0 30px !important;
}
/deep/.el-submenu .el-submenu .el-submenu .el-submenu__title {
  padding: 0 30px !important;
}
/deep/.el-submenu .el-submenu .el-submenu .el-menu-item {
  padding: 0 40px !important;
}
.el-menu-item {
  height: 56px;
  line-height: 56px;
  padding: 0 10px !important;
}
.svg-icon {
  width: 24px;
  text-align: center;
  vertical-align: middle;
  margin-right: 6px;
}
.placeholder {
  width: 20px;
  display: inline-block;
}
</style>
